"use client";
import { Button, Input } from "@heroui/react";
import { MdOutlineMailOutline } from "@/components/icons";

export default function SubscribeContainer() {
  return (
    <div className="w-full rounded-medium py-4 lg:flex lg:items-center lg:justify-between lg:gap-2">
      <div>
        <h3 className="text-small font-semibold text-default-600">
          Subscribe to our newsletter
        </h3>
        <p className="mt-2 text-small text-default-500">
          Receive weekly updates with news, latest events, ticket discounts and
          everything in techno music.
        </p>
      </div>
      <form className="mt-6 flex  flex-col sm:flex-row sm:max-w-lg w-full lg:mt-0 gap-2 items-center justify-center">
        <Input
          id="newsletter-email"
          variant="bordered"
          className="h-12 w-full"
          label="Email"
          type="email"
          name="email"
          aria-label="Email"
          autoComplete="email"
          classNames={{ inputWrapper: "rounded-md" }}
          //   startContent={
          //     <MdOutlineMailOutline className="text-default-500 h-4 w-4" />
          //   }
        />
        <Button
          // as={Link}
          color="primary"
          className="text-primary-foreground font-semibold tracking-wider rounded-md uppercase w-full sm:w-36 h-[2.9rem]"
          variant="shadow"
        >
          Subscribe
        </Button>
      </form>
    </div>
  );
}
